import emitter from './emitter';
/**
 * h5向移动端发送消息
 */
export function postMessage(obj, fn) {
  const defaultMessage = {
    type: '',
    data: {},
  };
  obj = Object.assign(defaultMessage, obj);

  if (fn) {
    let id = new Date().getTime() + '';
    if (obj.data.callbackId) {
      id = obj.data.callbackId;
    } else {
      obj.data.callbackId = id;
    }
    function callback(val) {
      const { callbackId, data } = val;
      if (callbackId === id) {
        fn(data);
        emitter.removeListener('nativeMessage', callback);
      }
    }
    emitter.addListener('nativeMessage', callback);
  }
  console.log(obj);
  global.webkit &&
    global.webkit.messageHandlers &&
    global.webkit.messageHandlers.IOS &&
    global.webkit.messageHandlers.IOS.postMessage &&
    global.webkit.messageHandlers.IOS.postMessage(JSON.stringify(obj));

  global.android &&
    global.android.postMessage &&
    global.android.postMessage(JSON.stringify(obj));

  global.ohos &&
    global.ohos.postMessage &&
    global.ohos.postMessage(JSON.stringify(obj));
}
/**
 * 开放方法，用于移动端向h5发送消息
 */
export function postContainerMessage(obj) {
  console.log(obj);
  emitter.emit('nativeMessage', JSON.parse(obj));
}

export function postNativeMessage(obj) {
  let result = {};
  console.log(obj);
  try{
    result = JSON.parse(obj)
  }catch(err){
    console.log('json转换异常:', obj +'');
  }
  emitter.emit('nativeMessage', result);
}
